import type { DirectiveBinding } from 'vue'

export const vDebounce = {
  mounted: (el: HTMLElement, binding: DirectiveBinding) => {
    const [fn, event = 'click', time = 500] = binding.value
    let timer: any
    let flag = true // 输入法标记
    if (event === 'input') {
      el.addEventListener('compositionstart', () => {
        flag = false
      })
      el.addEventListener('compositionend', () => {
        flag = true
      })
    }
    el.addEventListener(event, () => {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        if (flag) {
          fn()
        }
      }, time)
    })
  },
}
